import React from 'react'
import { IIconProps } from './Icon/Interfaces'

const UploadIcon = ({
  width=20,
  height=20,
  strokeColor='var(--blue)',
}: IIconProps) => {
  return (
    <svg width={width} height={height} viewBox="0 0 61 61" fill="none">
      <path
        d="M3 21.224V9.074A6.075 6.075 0 0 1 9.074 3h42.523a6.075 6.075 0 0 1 6.075 6.075v12.15"
        stroke={strokeColor}
        strokeWidth="5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M45.523 36.408 30.337 21.222 15.15 36.408M30.336 21.223V57.67"
        stroke={strokeColor}
        strokeWidth="5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default UploadIcon
